export const quickviewProductViewEvent = (data = {}) => {
  const quickviewProductViewCustomEvent = new CustomEvent('ProductQuickView', {
    detail: {
      data,
    },
  });
  document.dispatchEvent(quickviewProductViewCustomEvent);
};

export const quickviewProductAddToCartEvent = (data = {}) => {
  const quickviewProductAddToCartCustomEvent = new CustomEvent('AddToCart', {
    detail: {
      data,
    },
  });
  document.dispatchEvent(quickviewProductAddToCartCustomEvent);
};

export const changePreferredStoreEvent = (storeId = 0) => {
  const changePreferredStoreCustomEvent = new CustomEvent('ChangePreferredStore', {
    detail: {
      NewStoreID: storeId,
    },
  });
  document.dispatchEvent(changePreferredStoreCustomEvent);
};

export const quickviewProductRemoveFromFavoritesEvent = (data = '', sku = '') => {
  const productData = {
    ProductID: data,
  };
  const evt = new CustomEvent('RemoveFromFavorites', {
    detail: sku ? { ...productData, ProductSku: sku } : productData,
  });
  document.dispatchEvent(evt);
};

export const quickviewProductAddToFavoritesEvent = (data = '', sku = '') => {
  const productData = {
    ProductID: data,
  };
  const evt = new CustomEvent('AddToFavorites', {
    detail: sku ? { ...productData, ProductSku: sku } : productData,
  });
  document.dispatchEvent(evt);
};

export const multiListAddRemoveFromFavoritesEvent = (data = {}, NumberOfLists = 0, action = '') => {
  const eventMessages = {
    add: 'AddToList',
    remove: 'RemoveFromList',
  };
  const { ecode: ProductID, sku: ProductSku } = data;
  const productData = {
    ProductID,
    ProductSku,
    NumberOfLists,
  };
  const evt = new CustomEvent(eventMessages[action], {
    detail: productData,
  });
  document.dispatchEvent(evt);
};

export const cartEditProductEvent = (detail = {}) => {
  const evt = new CustomEvent('CartEditProduct', {
    detail,
  });
  document.dispatchEvent(evt);
};

export const quickViewFullPDPClickEvent = () => {
  const evt = new CustomEvent('QuickViewFullPDPClick', {});

  document.dispatchEvent(evt);
};

export const signOutAddToListEvent = () => {
  const evt = new CustomEvent('SignOut_AddToList', {});

  document.dispatchEvent(evt);
};
